import d from "./extends3.mjs";
import { useIsLandscape as r } from "./useIsLandscape.mjs";
const u = ({
  props: t,
  propsFromPickerValue: o,
  propsFromPickerViews: e,
  wrapperVariant: s
}) => {
  const {
    orientation: a
  } = t, n = r(e.views, a);
  return {
    layoutProps: d({}, e, o, {
      isLandscape: n,
      wrapperVariant: s,
      disabled: t.disabled,
      readOnly: t.readOnly
    })
  };
};
export {
  u as usePickerLayoutProps
};
//# sourceMappingURL=usePickerLayoutProps.mjs.map
